import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { copyRole, resetFilters, setSelected } from "../redux/rolesSagas";
import { MainModal } from "../../../../components/modal/MainModal";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { ErrorList } from "./ErrorList";

export const Copy = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    currentUser: { organizations },
    selected: { selectedOrganizations, organization, name },
    status,
    errors
  } = useSelector((state) => state.roles);

  const currentOrganizations = organizations.filter((org) => org.id !== organization?.id);

  const primaryBtnHandler = () => {
    dispatch(copyRole());
  };

  useEffect(() => {
    if (status == "success") {
      close();
    }
  }, [status]);

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const onOrgsChange = (data) => {
    dispatch(setSelected({ selectedOrganizations: data }));
  };

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".roles"
      headerText={`Copy Role : ${name}`}
      headerCloseHandler={close}
      bodyClassName="main-popup-body"
      primaryButtonText="Save"
      primaryButtonClass="primary-btn"
      primaryButtonDisabled={false}
      primaryBtnHandler={() => primaryBtnHandler()}
      secondaryBtnText="Cancel"
      secondaryBtnClass="secondary-btn"
      secondaryBtnHandler={close}
      width={700}
      height={300}
    >
      <Dropdown
        height={275}
        haveOnSelectChange
        placeholder="Select Organizations"
        options={currentOrganizations}
        selectedFilters={selectedOrganizations}
        numberDisplayed={7}
        includeSelectAll
        onSelectChange={(data) => onOrgsChange(data)}
      />

      <ErrorList errors={errors} />
    </MainModal>
  );
};
